import React, { createContext, useContext, useState, useEffect, useRef } from 'react';

interface FooterContextProps {
  footerHeight: number;
  footerRef: React.RefObject<HTMLElement>;
}

const FooterContext = createContext<FooterContextProps>({
  footerHeight: 0,
  footerRef: { current: null }
});

export const useFooterHeight = () => useContext(FooterContext);

export const FooterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [footerHeight, setFooterHeight] = useState(0);
  const footerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const updateFooterHeight = () => {
      if (footerRef.current) {
        setFooterHeight(footerRef.current.offsetHeight);
      }
    };

    updateFooterHeight();
    window.addEventListener('resize', updateFooterHeight);

    return () => {
      window.removeEventListener('resize', updateFooterHeight);
    };
  }, []);

  return (
    <FooterContext.Provider value={{ footerHeight, footerRef }}>
      {children}
    </FooterContext.Provider>
  );
};
